let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("84SAq"), load("5ZMuJ"), load("c37CC")]).then(() => parcelRequire('cVptH'));